<div class="container">
  <h2 class="text-center">{{ id ? 'Edit Work Update' : 'Add Work Update' }}</h2>
<mat-card>
<!--  <prettyjson [obj]="workForm.value"></prettyjson>-->
  <form [formGroup]="workForm">
    <div class="row">
      <app-searchable-select class="col-md-4"
                             [required]="true"
                             [multiple]="true"
                             [options]="centres$ | async"
                             [selectedValue]="selectedCentre"
                             [displayWithFn]="displayCentre"
                             [placeholder]="'Select Centre'"
                             [label]="'Select Centre'"
                             (selectionChange)="onCentreSelect($event)"
      ></app-searchable-select>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Type Of Teacher</mat-label>
        <mat-select formControlName="teacherType" (selectionChange)="onTeacherSelection($event)">
          <mat-option *ngFor="let t of teacherTypes" [value]="t">
            {{ t }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Task / Activities</mat-label>
        <textarea
          matInput
          rows="3"
          formControlName="task"
          placeholder="Enter up to 500 characters"
        ></textarea>

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Remarks</mat-label>
        <textarea
          matInput
          rows="2"
          formControlName="remarks"
          placeholder="Enter up to 500 characters"
        ></textarea>
      </mat-form-field>

      <div class="justify-content-center d-flex gap-2">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="submit()" [disabled]="workForm.invalid || isLoading" >Update</button>
      </div>
    </div>
  </form>
</mat-card>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
